module.exports = __webpack_public_path__ + "media/components/lesson2/statics/receiveMessage-ec1475a3ddf629aec412df98c1ff5e2e.png";